/**
 * Shared save/close timing for form modals.
 * - closeAfterSave: await save (selection applied) then close — create-from-search
 * - default: close immediately, save in background — list CRUD snappy UX
 */
export async function commitFormSave(options: {
  closeAfterSave: boolean;
  onSave: () => void | Promise<void>;
  onClose: () => void;
  setSaving?: (saving: boolean) => void;
  onError?: (error: unknown) => void;
}): Promise<void> {
  const { closeAfterSave, onSave, onClose, setSaving, onError } = options;

  if (closeAfterSave) {
    setSaving?.(true);
    try {
      await Promise.resolve(onSave());
      onClose();
    } catch (error: unknown) {
      onError?.(error);
      console.error('Error saving form:', error);
    } finally {
      setSaving?.(false);
    }
    return;
  }

  onClose();
  Promise.resolve(onSave()).catch((error: unknown) => {
    onError?.(error);
    console.error('Error saving form:', error);
  });
}
